export class GameAudio {
  private context: AudioContext | null = null;
  private enabled = true;

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }

  play(kind: 'click' | 'reward' | 'danger' | 'launch'): void {
    if (!this.enabled) return;
    try {
      this.context ??= new AudioContext();
      const oscillator = this.context.createOscillator();
      const gain = this.context.createGain();
      const now = this.context.currentTime;
      const frequencies = {
        click: [420, 520],
        reward: [520, 780],
        danger: [170, 120],
        launch: [240, 460],
      };
      const [start, end] = frequencies[kind];
      oscillator.type = kind === 'danger' ? 'sawtooth' : 'sine';
      oscillator.frequency.setValueAtTime(start, now);
      oscillator.frequency.exponentialRampToValueAtTime(end, now + 0.11);
      gain.gain.setValueAtTime(0.0001, now);
      gain.gain.exponentialRampToValueAtTime(kind === 'danger' ? 0.08 : 0.045, now + 0.012);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.16);
      oscillator.connect(gain).connect(this.context.destination);
      oscillator.start(now);
      oscillator.stop(now + 0.18);
    } catch {
      // Audio is optional and may be blocked by browser policy.
    }
  }
}
